import React, { useEffect, useState } from "react";
import { Column } from "@ant-design/plots";
import "./DashboardBarChart.css";
import { ProgressSpinner } from "primereact/progressspinner";

const DashboardBarChart = ({
  xField,
  yField,
  unit,
  title,
  graphData,
  tooltipText,
  loading,
}) => {
  const handleKgLabel = () => {
    return (
      <span>
        Energy Consumed per Vehicle (L, kWh, kgH<sub>2</sub>, etc)
      </span>
    );
  };

  function roundToFourDecimals(value) {
    return Number(Math.floor(value * 100) / 100);
  }
  const [config, setConfig] = React.useState({
    data: graphData,
    xField: xField,
    yField: yField,
    label: {
      position: "top",
      style: {
        fill: "#FFFFFF",
        opacity: 0.6,
      },
    },
    width: 200,
    height: 200,
    color: "colorName",
    tooltip: {
      formatter: (datum) => {
        return {
          name: tooltipText === "kgh2" ? handleKgLabel() : tooltipText,
          value: roundToFourDecimals(datum[yField]),
        };
      },
    },
    xAxis: {
      label: {
        autoHide: true,
        autoRotate: false,
      },
    },
  });

  useEffect(() => {
    setConfig({
      data: graphData,
      xField: xField,
      yField: yField,
      label: {
        position: "top",
        style: {
          fill: "#FFFFFF",
          opacity: 0.6,
        },
      },
      width: 200,
      height: 200,
      color: "colorName",
      tooltip: {
        formatter: (datum) => {
          return {
            name: tooltipText,
            value: roundToFourDecimals(datum[yField]),
          };
        },
      },
      xAxis: {
        label: {
          autoHide: true,
          autoRotate: false,
        },
      },
    });
  }, [graphData]);

  const handleH2Unit = () => {
    return unit === "(kg H2)" ? (
      <span>
        (kg H<sub>2</sub>)
      </span>
    ) : (
      unit
    );
  };

  return (
    <div className={`col dashBarCard ${loading ? "fit-content" : ""}`}>
      {loading ? (
        <ProgressSpinner
        // style={{ height: "50px", width: "50px" }}
        />
      ) : (
        <div className="card border-noround surface-50">
          <strong>{title === "kgh2" ? handleKgLabel() : title}</strong>

          <div className="barChart">
            <div className="kpiClassKm">{handleH2Unit()}</div>
            <Column {...config} />{" "}
          </div>
        </div>
      )}
    </div>
  );
};

export default DashboardBarChart;
